import { render } from "./PromoItem.vue?vue&type=template&id=173324e4"
import script from "./PromoItem.vue?vue&type=script&lang=js"
export * from "./PromoItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__